import { render, staticRenderFns } from "./GameTag.vue?vue&type=template&id=41e7df0e&scoped=true"
import script from "./GameTag.vue?vue&type=script&lang=js"
export * from "./GameTag.vue?vue&type=script&lang=js"
import style0 from "./GameTag.vue?vue&type=style&index=0&id=41e7df0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7df0e",
  null
  
)

export default component.exports